<div class="close_icon_wrapper" (click)="close()" >
    <app-svg-icon class="close_icon" [path]="'/assets/icons/close_icon.svg'"></app-svg-icon>
</div>